import axios, { handleResponse } from "utils/axios";

const signUp = async (captchaToken, data) => {
  return axios({
    method: "post",
    url: "/merchants/register",
    data,
    headers: {
      recaptcha: captchaToken,
    },
  });
};

const getGoogleAuthenInfo = async () => {
  return axios({
    method: "get",
    url: "/merchants/get-image-2fa",
  }).then(handleResponse);
};

/*
 * data form: { fa_otp_token: <String>6 digitsCode }
 * */
const setup2FA = async (data) => {
  return axios({
    method: "post",
    url: "/merchants/setup-2fa",
    data,
  });
};

/*
 * data form: { wallets: <Array>[{ address: string, network: string, currency: string }] }
 * */
const setupWallet = async (data) => {
  return axios({
    method: "post",
    url: "/merchants/setup-wallet",
    data,
    timeout: 60000 * 5,
  });
};

export { signUp, getGoogleAuthenInfo, setup2FA, setupWallet };
